module.exports = __webpack_public_path__ + "img/logo1.905046a9.png";